<template>
  <div class="series-list-item-footer">
    <div class="stack">
      <div class="item" v-for="stack in itemStack" :key="stack.id">
        <StackIcon :name="stack.name" color="#fff" background="light" />
      </div>
    </div>
    <div class="meta">
      <div class="item pack-count">{{ item.packCount }} 集</div>
      <div class="item node-count">{{ item.nodeCount }} 节</div>
      <div class="item duration">{{ item.duration }}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import StackIcon from '@/stack/components/stack-icon';

export default defineComponent({
  name: 'SeriesListItemFooter',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    itemStack() {
      let stacks = this.item.stacks;

      if (stacks && stacks.length > 6) {
        stacks = stacks.filter((item, index) => index > 0 && index < 5);
      }

      return stacks;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    StackIcon,
  },
});
</script>

<style scoped>
@import './styles/series-list-item-footer.css';
</style>
